import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.some";
import "core-js/modules/es.string.includes";
import store from '@/store';
/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/oneLevel/index.vue
 */

export default function checkPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    var roles = store.getters && store.getters.roles;
    var permissionRoles = value;
    var hasPermission = roles.some(function (role) {
      return permissionRoles.includes(role);
    });

    if (!hasPermission) {
      return false;
    }

    return true;
  } else if (value && value instanceof Array) {
    return true;
  } else {
    console.error("need roles! Like v-permission=\"['admin','editor']\"");
    return false;
  }
}